import { theme } from "../../config/theme";

const styles = {
  general: {
    borderRadius: "100px",
    textTransform: "none",
    fontFamily: "sans-serif"
  },
  primary: {
    "background": theme.palette.primary.darkGreen,
    "color": theme.palette.primary.white,
    "padding": "6px 16px",
    "&:hover": {
      background: theme.palette.primary.darkGreen,
      opacity: 0.8
    },
    "&:disabled": {
      color: theme.palette.primary.white,
      opacity: 0.6
    }
  },
  secondary: {
    "background": theme.palette.primary.white,
    "color": theme.palette.primary.darkGray,
    "border": `1px solid ${theme.palette.primary.gray}`,
    "padding": "8px 16px",
    "margin": "0 4px",
    "&:hover": {
      background: theme.palette.primary.lightGray
    },
    "&:focus": {
      border: `1px solid ${theme.palette.primary.lightGreen}`,
      background: theme.palette.primary.lightGreen,
      color: theme.palette.primary.darkGreen,
      outline: "none"
    }
  },
  selected: {
    "border": `1px solid ${theme.palette.primary.lightGreen}`,
    "background": theme.palette.primary.lightGreen,
    "color": theme.palette.primary.darkGreen,
    "padding": "8px 16px",
    "margin": "0 4px",
    "&:hover": {
      background: theme.palette.primary.lighterGreen,
      borderColor: theme.palette.primary.lighterGreen
    }
  }
};

export { styles };
